// extracted by mini-css-extract-plugin
module.exports = {"container":"OutlineButton_container__OXZQF","hover":"OutlineButton_hover__MqEiY"};